

export const TWITTER_SHARE_URL = 'https://twitter.com/share';
export const FACEBOOK_SHARE_URL = 'https://www.facebook.com/share.php';
export const LINE_SHARE_URL = 'https://line.me/R/msg/text/';



// WEBPACK FOOTER //
// ./src/js/app/constant/shareEndpoint.js